// extracted by mini-css-extract-plugin
export default {"button":"BCwJhqZfVR1Qs2wIq8Jm","innerButton":"vgn5oDz9YV6svZTghHYv","innerText":"d0_7NEuzbWULr6AlzL2g","bounce":"PKo1uUzSlCvHA7m7k5HM"};